module.exports = __webpack_public_path__ + "static/media/logo.d686f443.jpeg";